export default __webpack_public_path__ + "static/media/sf1.8e4b6276.svg";